'use client';

import { useState } from 'react';
import { cn } from '@/lib/utils';
import { Button } from '../ui/button';
const HEIGHT = {
  sm: 'h-[150px]',
  default: 'h-[300px]'
} as const;
const classes = {
  wrapper: 'relative',
  description: {
    base: 'relative text-secondary-readable',
    truncated: 'overflow-hidden [-webkit-mask-image:linear-gradient(rgb(0,0,0),transparent)]'
  },
  showMoreButton: 'pl-0 font-mono text-secondary lowercase'
};
interface TruncatingWrapperProps {
  text?: string;
  maxLength: number;
  children: JSX.Element;
  height?: keyof typeof HEIGHT;
}
export function TruncatingWrapper({
  text = '',
  children,
  maxLength = 255,
  height = 'default'
}: TruncatingWrapperProps) {
  const [isCollapsed, setIsCollapsed] = useState(text.length > maxLength);
  return <div className={classes.wrapper}>
      <div className={cn(classes.description.base, {
      [classes.description.truncated]: isCollapsed,
      [HEIGHT[height]]: isCollapsed
    })}>
        {children}
      </div>
      {(isCollapsed || text.length > maxLength) && <Button className={cn(classes.showMoreButton, {
      ['mt-5']: !isCollapsed
    })} type="button" onClick={() => setIsCollapsed(!isCollapsed)} variant="link">
          Show {isCollapsed ? 'more' : 'less'}
        </Button>}
    </div>;
}